import React from 'react';
import styles from '../app/App.scss';
import { t } from '../../services/i18nService';
import a11yIcewormService from '../../services/a11yIcewormService';

const SkipLink = () => {
    const skipLinkClickHandler = (evt) => {
        document.getElementById('footer-nav-wrapper').focus();
        evt.preventDefault();
        return false;
    };

    const isIcewormFeatureEnabled = a11yIcewormService.isIcewormHandoffEnabled();

    return (
        <button
            {...(isIcewormFeatureEnabled && { id: 'skip-to-nav-link' })}
            className={styles.skipToNavigationLink}
            onClick={skipLinkClickHandler}
            aria-label={t('main.skipLinkAriaLabelText')}
        >
            {t('main.skipLink')}
        </button>
    );
};

export default SkipLink;
